import React from 'react';
import Title from './title';
import Btn from './btn';

const TextCard = ({ category, features }) => {
  return (
    <div className="category-text-card">
      <Title title={category} t="titlew" /> 
      <ul className="feature-list">
        {features.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <Btn btn="Book Now" />
    </div>
  );
};

export default TextCard;